exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".drag-text {\n    padding-left: 116px;\n    padding-top: 21px;\n  }\n  \n  .image-table {\n    display: flex;\n    flex-wrap: wrap;\n    grid-gap: 41px;\n    width: 110%;\n  }\n  \n  .image-button {\n    margin: -53px 0px 0px 106px;\n  }\n  \n  .image-content {\n    width: 310px;\n  }\n\n  .hidden {\n    display: none;\n  }", ""]);

